import { useState } from "react";
import { Icon } from "./icons";

interface ShareModalProps {
  shareUrl: string;
  onClose: () => void;
}

export function ShareModal({ shareUrl, onClose }: ShareModalProps) {
  const [copyState, setCopyState] = useState<"idle" | "copying" | "copied">("idle");

  const handleCopy = async () => {
    if (copyState === "copying") return;
    setCopyState("copying");
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      const el = document.querySelector<HTMLElement>("[data-share-url]");
      if (el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }
    setCopyState("copied");
    // Hold the "Copied" state briefly so the user sees the confirmation,
    // then auto-dismiss the modal — avoids a redundant manual close.
    setTimeout(() => onClose(), 600);
  };

  return (
    <div className="modal-scrim" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <h3 className="modal-title">Share sample</h3>
            <p className="modal-sub">Anyone with this link can listen.</p>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            <Icon.X />
          </button>
        </div>

        <div
          data-share-url
          style={{
            padding: 12,
            borderRadius: 8,
            background: "oklch(0.14 0.012 265)",
            border: "1px solid var(--hair)",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            color: "var(--ink-2)",
            wordBreak: "break-all",
            lineHeight: 1.5,
          }}
        >
          {shareUrl}
        </div>

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCopy}
            disabled={copyState === "copying"}
          >
            {copyState === "copied" ? (
              <>
                <Icon.Check /> Copied
              </>
            ) : (
              <>
                <Icon.Link /> Copy link
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
